export default {
    data:       [],
    graph:      null,
    totalCount: 0,
};
